<template>
	<div class="his-gifts-wrap">
		<div class="page-header">
			<span class="back-btn" @click="closeList"><img src="../../assets/img/chats/ic_nav_back_pressed@2x.png"/></span>
			<p class="page-title">Ta收到的礼物</p>
			<span class="more-btn" @click="showBox">礼物箱</span>
		</div>
		<p class="tips">送礼获取积分，收到的礼物可以兑换成实物或出售给平台哦</p>
		<div class="gift-list">
			<mt-loadmore :top-method="refreshList" :bottom-method="loadMoreList" :auto-fill="false" ref="loadmore">
			<ul>
				<li v-for="(item,index) in listInfo">
					<span class="item-avatar"><img :src="item.avatar"/></span>
					<div class="item-text">
						<p class="name">
							{{index+1}}.{{item.nickname}}
							<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
							<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
							<img v-if="item.is_vip==1" src="../../assets/img/common/ic_user_vip@2x.png"/>
						</p>
						<p class="text">消费{{item.price}}个桃花币</p>
					</div>
					<span class="item-img">
						<img :src="item.girft_img_url"/>
					</span>
				</li>
			</ul>
			</mt-loadmore>
		</div>
	</div>
</template>

<script>
	export default{
		name:"his-gifts",
		props:["uid"],
		data(){
			return{
				listInfo:"",
				nowPage:1,
			}
		},
		created(){
			this.getList();
		},
		methods:{
			getList(){
				this.$axios({
					url:"My/OtherGiftList",
					method:"post",
					data:{
						uid:this.uid,
						page:this.nowPage
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						})
						if(this.nowPage==1){
							this.listInfo = res.data.data;
						}else{
							if(res.data.data.length<1){
								
								this.nowPage--;
							}else{
								this.listInfo = this.listInfo.concat(res.data.data);
							}
						}
					}else{
						
						this.$toast({
							message:"没有更多内容了",
							position:"bottom",
							duration:3000
						})
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			refreshList(){
				this.nowPage = 1;
				this.getList();
				this.$refs.loadmore.onTopLoaded();
			},
			loadMoreList(){
				this.nowPage++;
				
				this.getList();
				this.$refs.loadmore.onBottomLoaded();
			},
			showBox(){
				this.$emit("showBox")
			},
			closeList(){
				this.$emit("closeList")
			}
		}
	}
</script>

<style scoped>
.his-gifts-wrap{
	width: 100vw;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	background: #fff;
	z-index: 10;
}
.page-header{
	width: 100%;
	height: 2.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 0.95rem;
	color: #282828;
}
.page-header img{
	width: 2.5rem;
}
.page-header .more-btn{
	color: #5415F9;
	margin-right: 1rem;
}
.tips{
	font-size: 0.8rem;
	color: #5415F9;
	background: rgba(84,21,249,.1);
	line-height: 1.5rem;
	padding: 0.3rem 1rem;
	opacity: 0.8;
}
.gift-list{
	height: calc(100vh - 4.63rem);
	overflow-y: scroll;
}
.gift-list li{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.3rem 1rem;
	border-bottom: 1px solid #f3f3f3;
}
.gift-list li .item-avatar img{
	width: 2.6rem;
	height: 2.6rem;
	border-radius: 50%;
	display: block;
}
.gift-list li .item-img img{
	width: 2rem;
	display: block;
}
.gift-list li .item-text{
	flex: 1;
	padding: 0 0.5rem;
}
.gift-list li .item-text .name{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	font-size: 0.95rem;
	color: #282828;
	font-weight: bold;
}
.gift-list li .item-text .name img{
	width: 1.5rem;
}
.gift-list li .item-text .text{
	font-size: 0.8rem;
	color: #7b7b7b;
}
</style>


// WEBPACK FOOTER //
// src/components/Mine/HisGifts.vue